import TaskDetails from "../../components/TaskDetails";
import { isProspectingSuggestion } from "../../commercial/services/task-routing.mjs";
import PageHeading from "../../components/PageHeading";
import SearchPending from "../../components/SearchPending";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";
import { createListSearch } from "../../utils/listSearch";
import { apiErrorMessage } from "../../utils/apiError";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Input } from "../../components/reusableComponents/Input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/Tabs";
import { Badge } from "../../components/reusableComponents/Badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/reusableComponents/Dialog";
import { Label } from "../../components/reusableComponents/Label";
import { DayPicker } from "react-day-picker";
import TaskModal from "../../components/reusableComponents/TaskModal";
import axios from "../../axios/AxiosInstance";
import { fr } from "date-fns/locale";
import { formatJsDate } from "../../utils/formatageDate";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Search, Calendar, Clock, User, CheckCircle2, AlertCircle, Circle, Filter, MoreHorizontal, Edit3, Trash2, Eye, CalendarDays, Users, Activity, Loader2 } from "lucide-react";

const Task = ({ embedded = false, integrated = false, integratedDate = false, tableView = false, date: dayDate, additionalTasks = null, onOpenCommercialTask }) => {
  const [apiTasks, setApiTasks] = useState([]);
  const setTasks = rows => setApiTasks(previous => (typeof rows === "function" ? rows(previous) : rows).filter(task => !task.commercialTask));
  const tasks = useMemo(() => [...apiTasks, ...(additionalTasks || [])].filter(task => !isProspectingSuggestion(task)), [apiTasks, additionalTasks]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [takers, setTakers] = useState([]);
  const attributionName = person => {
    if (!person) return "Non renseigné";
    if (typeof person === "object") {
      const name = [person.firstname, person.lastname].filter(Boolean).join(" ") || person.name;
      if (name) return name;
    }
    const id = String(person._id || person.id || person);
    return takers.find(user => String(user.value) === id)?.label || (id === "Automatisme" ? id : "Non renseigné");
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearch, searching] = useDebouncedValue(searchTerm);
  const [taskError, setTaskError] = useState("");
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [activeTab, setActiveTab] = useState("A faire");
  const isOverdue = task => !/effectu|faite|termin|annul|^done$|^cancelled$/i.test(task.status || "") && String(task.date || "").slice(0, 10) < selectedDate;
  const [isUpdating, setIsUpdating] = useState(false);
    const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10),
  );

  const taskRequest = useRef(null);
  useEffect(() => () => taskRequest.current?.abort(), []);
  const loadTasks = (date) => {
    taskRequest.current?.abort();
    const controller = new AbortController();
    taskRequest.current = controller;
    setLoadingTasks(true);
    setTaskError("");
    axios
      .get(`/newtask/find-by-date?date=${encodeURIComponent(date)}`, {signal:controller.signal})
      .then((res) => {
        if (controller.signal.aborted) return;
        setTasks(res.data);
        filtrerTaches(activeTab, appliedSearch, res.data);
      })
      .catch((error) => {
        const detail = apiErrorMessage(error, "Impossible de charger les tâches.");
        if (detail) setTaskError(detail);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoadingTasks(false);
      });
  };

  useEffect(() => {
    const date = dayDate || new Date().toISOString();
    if (dayDate) setSelectedDate(dayDate);
    loadTasks(date);
    getAgencyUsers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayDate]);

  useEffect(() => {
    const refresh = () => loadTasks(dayDate || selectedDate);
    const timer = setInterval(refresh, 20000);
    window.addEventListener("focus", refresh);
    return () => {clearInterval(timer);window.removeEventListener("focus", refresh);};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayDate, selectedDate, activeTab, appliedSearch]);

  // État du formulaire d'ajout/modification
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [, setIsViewMode] = useState(false);
  const [currentTask, setCurrentTask] = useState({});
  const [detailTask, setDetailTask] = useState(null);

  // Compter les tâches par statut
  const taskCounts = {
    all: tasks.length,
    todo: tasks.filter(
      (task) => task.status !== "Effectuée" && task.status !== "annulée",
    ).length,
    done: tasks.filter((task) => task.status === "Effectuée").length,
    cancelled: tasks.filter((task) => task.status === "annulée").length,
  };

  // Fonction pour filtrer les tâches
  // Trie les tâches par priorité: haute > moyenne > basse
  const trierParPriorite = (tasks) => {
    const priorityOrder = { urgent: 0, Urgent: 0, high: 1, Haute: 1, medium: 2, Moyenne: 2, low: 3, Basse: 3 };
    return [...tasks].sort((a, b) => {
      return Number(isOverdue(b)) - Number(isOverdue(a)) || (priorityOrder[a.priority] ?? 4) - (priorityOrder[b.priority] ?? 4);
    });
  };

  const getAgencyUsers = () => {
    axios("newtask/recipients").then((res) => {
      const usersArray = res.data.map((user) => {
        return {
          value: user._id,
          label: `${user.firstname || ""} ${user.lastname || ""} — ${user.role === "FREELANCE" ? "Freelance" : "Admin"}`,
          key: user._id,
        };
      });
      setTakers(usersArray);
    }).catch((error) => {
      const detail = apiErrorMessage(error, "Impossible de charger les utilisateurs de l’agence.");
      if (detail) setTaskError(detail);
    });
  };

  const updateOnCreate = (task) => {
    console.log(selectedDate);
    const dateObj = new Date(task.date);
    const formattedDate = dateObj.toISOString().slice(0, 10);
    console.log(formattedDate);
    if (selectedDate === formattedDate) {
      console.log("okokokokoo");
      const newTasks = tasks.some(t => t._id === task._id) ? tasks.map(t => t._id === task._id ? task : t) : [...tasks, task];
      setTasks(newTasks);
      filtrerTaches(activeTab, appliedSearch, newTasks);
    }
  };

  const filtrerTaches = (tab, search, newTasks = tasks) => {
    let resultats;
    resultats = newTasks.filter(task => !isProspectingSuggestion(task));

    if (tab === "A faire") {
      resultats = resultats.filter(
        (task) => task.status !== "Effectuée" && task.status !== "annulée",
      );
    }

    // Filtre par statut
    else if (tab === "late") {
      resultats = resultats.filter(isOverdue);
    }
    else if (tab !== "all") {
      resultats = resultats.filter((task) => task.status === tab);
      console.log(resultats);
    }

    resultats = resultats.filter(createListSearch(search, ["title", "description", "comment", "taskType", "priority", "clients.companyName", "clients.town", "clients.contactPhone", "candidates.firstname", "candidates.lastname", "candidates.phone", "assignedTo.firstname", "assignedTo.lastname"]));

    // Filtre par date sélectionnée
    //resultats = resultats.filter(task => task.date === selectedDate);
    console.log(resultats);

    // Trie par priorité
    resultats = trierParPriorite(resultats);
    console.log(resultats);

    setFilteredTasks([...resultats]);
  };

  // Gestionnaire de changement de recherche
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Gestionnaire de changement d'onglet
  const handleTabChange = (value) => {
    setActiveTab(value);
    filtrerTaches(value, appliedSearch);
  };

  // Gestionnaire de changement de date
  const handleDateChange = (e) => {
    const value = e.target.value;
    console.log(value);
    loadTasks(value);
    setSelectedDate(value);
    filtrerTaches(activeTab, appliedSearch);
  };

  useEffect(() => {
    filtrerTaches(activeTab, appliedSearch, tasks);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks, activeTab, appliedSearch]);

  // Fonction pour ouvrir le formulaire de nouvelle tâche
  const handleAddTask = () => {
    setCurrentTask({
      title: "",
      description: "",
      priority: "medium",
      status: "todo",
      assignedTo: "",
      taskType: "",
      contactType: "client",
      dueDate: selectedDate,
      tags: [],
    });
    setIsViewMode(false);
    setIsTaskModalOpen(true);
  };

  // Fonction pour ouvrir le formulaire de modification
  const handleEditTask = (task) => {
    setCurrentTask({ ...task });
    setIsUpdating(true);
    setIsViewMode(false);
    setIsTaskModalOpen(true);
  };

  // Fonction pour voir les détails d'une tâche
  const handleViewTask = (task) => {
    setDetailTask(task);
  };

  // Fonction pour sauvegarder une tâche
  
  // Fonction pour supprimer une tâche
  const handleDeleteTask = (id) => {
    const updatedTasks = tasks.filter((task) => task.id !== id);
    setTasks(updatedTasks);
    setFilteredTasks(
      updatedTasks.filter(
        (task) =>
          (activeTab === "all" || task.status === activeTab) &&
          task.dueDate === selectedDate,
      ),
    );
  };

  // Fonction pour changer le statut d'une tâche
  const handleStatusChange = (task, newStatus) => {
    const updatedTasks = tasks.map((t) =>
      t.id === task.id ? { ...t, status: newStatus } : t,
    );
    setTasks(updatedTasks);
    filtrerTaches(activeTab, appliedSearch);
  };

  // Obtenez une couleur en fonction du statut
  const getStatusColor = (status) => {
    switch (status) {
      case "todo":
        return "bg-amber-100 text-amber-800 border-amber-200"; // Changer ici la couleur en rouge;
      case "in-progress":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Effectuée":
        return "bg-green-100 text-green-800 border-green-200";
      case "cancelled":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-red-100 text-red-800 border-red-200";
    }
  };

  // Obtenez le statut en français
  const getStatusLabel = (status) => {
    switch (status) {
      case "to do":
        return "À faire";
      case "done":
        return "Terminée";
      case "cancelled":
        return "Annulée";
      default:
        return status;
    }
  };

  // Obtenez une couleur en fonction de la priorité
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "Basse":
        return "bg-green-100 text-green-800";
      case "Moyenne":
        return "bg-blue-100 text-blue-800";
      case "Haute":
        return "bg-orange-100 text-orange-800";
      case "Urgente":
        return "bg-red-100 text-red-800";
      default:
        return "bg-red-100 text-red-800";
    }
  };

  // Obtenez le label de la priorité en français
  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "Basse":
        return "Basse";
      case "Moyenne":
        return "Moyenne";
      case "Haute":
        return "Haute";
      case "Urgente":
        return "Urgente";
      default:
        return priority;
    }
  };

  const onOpenChange = () => {
    setIsTaskModalOpen(false);
    setIsUpdating(false);
  };

  return (
    <div className={embedded ? "w-full" : "w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100"}>
      <div className={embedded ? "w-full py-4" : "w-full p-8"}>
        {taskError && <p role="alert" className="mb-4 rounded-lg bg-rose-50 p-3 text-sm text-rose-700">{taskError}</p>}
        {loadingTasks && <p role="status" className="mb-4 flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Chargement des tâches…</p>}
        {/* Header Section */}
        {!integrated && <motion.div
          className="mb-8"
        >
          <div className="flex flex-wrap items-center justify-between gap-4">
            {!integrated && <div>
              <PageHeading icon="activity" title={<> Mes tâches </>} description={<> Organisez et suivez vos tâches quotidiennes efficacement </>} level={2} />
            </div>}
            <div className="flex items-center space-x-4">
              {!integrated && !integratedDate && <div className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-200">
                <Calendar className="w-4 h-4 text-slate-500" />
                <Input
                  type="date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  className="border-none bg-transparent text-sm font-medium text-slate-700 focus:ring-0"
                />
              </div>}

            </div>
          </div>
        </motion.div>}

        {/* Filtres et Recherche */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
        >
          <div className="grid min-w-0 grid-cols-1 items-center gap-4 mb-6 xl:grid-cols-[minmax(0,1fr)_auto]">
            <div className="min-w-0 max-w-full overflow-x-auto">
            <Tabs
              defaultValue="all"
              value={activeTab}
              onValueChange={handleTabChange}
              className="w-max"
            >
              <TabsList className="inline-flex h-auto w-max flex-nowrap whitespace-nowrap bg-slate-100 p-1 rounded-lg">
                {tableView && <TabsTrigger value="late">En retard <Badge className="ml-2 bg-orange-100 text-orange-700">{tasks.filter(isOverdue).length}</Badge></TabsTrigger>}
                <TabsTrigger
                  value="A faire"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <Circle className="w-4 h-4 mr-2 text-amber-500" />
                  À faire
                  <Badge className="ml-2 bg-amber-100 text-amber-700 text-xs px-2 py-0.5">
                    {taskCounts.todo}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="Effectuée"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <CheckCircle2 className="w-4 h-4 mr-2 text-emerald-500" />
                  Terminées
                  <Badge className="ml-2 bg-emerald-100 text-emerald-700 text-xs px-2 py-0.5">
                    {taskCounts.done}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="annulée"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <AlertCircle className="w-4 h-4 mr-2 text-red-500" />
                  Annulées
                  <Badge className="ml-2 bg-red-100 text-red-700 text-xs px-2 py-0.5">
                    {taskCounts.cancelled}
                  </Badge>
                </TabsTrigger>
                <TabsTrigger
                  value="all"
                  className="relative data-[state=active]:bg-white data-[state=active]:shadow-sm transition-all duration-200"
                >
                  <Activity className="w-4 h-4 mr-2 text-slate-500" />
                  Toutes
                  <Badge className="ml-2 bg-slate-100 text-slate-700 text-xs px-2 py-0.5">
                    {taskCounts.all}
                  </Badge>
                </TabsTrigger>
              </TabsList>
            </Tabs>

            </div>

            <div className="flex min-w-0 max-w-full flex-wrap items-center justify-end gap-3">
              <div className="relative min-w-0 flex-[1_1_180px] xl:w-52">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <Input
                  type="text"
                  placeholder="Rechercher une tâche..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="pl-10 bg-slate-50 border-slate-200 focus:bg-white transition-colors duration-200"
                />
                <div className="mt-1"><SearchPending pending={searching} /></div>
              </div>
              <motion.button
                className="flex items-center space-x-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Filter className="w-4 h-4" />
                <span className="hidden sm:inline">Filtres</span>
              </motion.button>
              <motion.button
                onClick={handleAddTask}
                className="flex shrink-0 items-center whitespace-nowrap space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg shadow-sm transition-colors duration-200"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Plus className="w-4 h-4" />
                <span className="font-medium">Nouvelle Tâche</span>
              </motion.button>
            </div>
          </div>

          {tableView && <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-slate-600"><tr>
                {["Priorité", "Échéance", "Clients concernés", "Candidats concernés", "Action à faire", "Attribution", "Statut", "Résultat de l’action", "Actions"].map(label => <th key={label} className="whitespace-nowrap px-4 py-3 font-semibold">{label}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-slate-100">
                {filteredTasks.map(task => <tr key={task._id} className="hover:bg-slate-50">
                  <td className="px-4 py-3"><Badge className={getPriorityColor(task.priority)}>{getPriorityLabel(task.priority)}</Badge></td>
                  <td className="whitespace-nowrap px-4 py-3">{formatJsDate(task.date)}<p className="mt-1 text-xs text-slate-500">{task.hour || "Heure libre"}</p></td>
                  <td className="px-4 py-3">{(task.clients || []).map(client => client.companyName || client.name).filter(Boolean).join(", ") || "—"}</td>
                  <td className="px-4 py-3">{(task.candidates || []).map(candidate => [candidate.firstname, candidate.lastname].filter(Boolean).join(" ") || candidate.name).filter(Boolean).join(", ") || "—"}</td>
                  <td className="min-w-[180px] px-4 py-3">{task.title || task.type}<p className="mt-1 whitespace-pre-wrap text-xs text-slate-500">{task.comment}</p></td>
                  <td className="min-w-[160px] px-4 py-3">
                    <small className="block text-xs text-slate-400">Attribuée par</small>
                    <span>{attributionName(task.taskCreator)}</span>
                    <small className="mt-2 block text-xs text-slate-400">Attribuée à</small>
                    <span>{(task.taskManagers || []).map(attributionName).join(", ") || "Non renseigné"}</span>
                  </td>
                  <td className="px-4 py-3"><Badge className={isOverdue(task) ? "bg-orange-100 text-orange-800" : getStatusColor(task.status)}>{isOverdue(task) ? "En retard" : getStatusLabel(task.status)}</Badge></td>
                  <td className="min-w-[180px] whitespace-pre-wrap px-4 py-3">{task.status === "annulée" ? task.cancelReason || "Non renseigné" : task.doneReason || "Non renseigné"}</td>
                  <td className="px-4 py-3"><button type="button" onClick={() => task.commercialTask ? onOpenCommercialTask?.(task.commercialTask) : setDetailTask(task)} className="rounded-lg border border-slate-200 px-3 py-2 text-blue-700 hover:bg-blue-50">Voir la tâche</button></td>
                </tr>)}
                {!filteredTasks.length && !loadingTasks && <tr><td colSpan={9} className="px-4 py-8 text-center text-slate-500">Aucune tâche pour cette date et ce filtre.</td></tr>}
              </tbody>
            </table>
          </div>}
          {!tableView && <Tabs
            defaultValue="all"
            value={activeTab}
            onValueChange={handleTabChange}
            className="w-full"
          >
            <TabsContent value="all" className="mt-6">
                <motion.div
                  className="space-y-4"
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                      >
                        <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <Activity className="w-8 h-8 text-slate-400" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche trouvée
                        </h3>
                        <p className="text-slate-500 mb-6">
                          Vous n'avez aucune tâche pour cette date ou ce filtre.
                        </p>
                        <motion.button
                          onClick={handleAddTask}
                          className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors duration-200"
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          <Plus className="w-4 h-4" />
                          <span>Créer votre première tâche</span>
                        </motion.button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="A faire" className="mt-6">
                <motion.div
                  className="space-y-4"
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                      >
                        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <Circle className="w-8 h-8 text-amber-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche à faire
                        </h3>
                        <p className="text-slate-500 mb-6">
                          Vous n'avez aucune tâche à faire pour cette date.
                        </p>
                        <motion.button
                          onClick={handleAddTask}
                          className="inline-flex items-center space-x-2 bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-lg transition-colors duration-200"
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          <Plus className="w-4 h-4" />
                          <span>Créer une nouvelle tâche</span>
                        </motion.button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="Effectuée" className="mt-6">
                <motion.div
                  className="space-y-4"
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                      >
                        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <CheckCircle2 className="w-8 h-8 text-emerald-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche terminée
                        </h3>
                        <p className="text-slate-500">
                          Vous n'avez aucune tâche terminée pour cette date.
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>

              <TabsContent value="annulée" className="mt-6">
                <motion.div
                  className="space-y-4"
                >
                  <AnimatePresence mode="wait">
                    {filteredTasks.length > 0 ? (
                      <motion.div
                        className="grid grid-cols-1 gap-4"
                      >
                        {filteredTasks.map((task, index) => (
                          <motion.div
                            key={task._id}
                          >
                            <TaskCard
                              task={task}
                              tasks={tasks}
                              filtrerTaches={filtrerTaches}
                              activeTab={activeTab}
                              setTasks={setTasks}
                              onEdit={() => handleEditTask(task)}
                              onView={() => handleViewTask(task)}
                              onDelete={() => handleDeleteTask(task.id)}
                              onStatusChange={handleStatusChange}
                              getStatusColor={getStatusColor}
                              getStatusLabel={getStatusLabel}
                              getPriorityColor={getPriorityColor}
                              getPriorityLabel={getPriorityLabel}
                            />
                          </motion.div>
                        ))}
                      </motion.div>
                    ) : (
                      <motion.div
                        className="bg-white rounded-xl border border-slate-200 p-12 text-center"
                      >
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                          <AlertCircle className="w-8 h-8 text-red-500" />
                        </div>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">
                          Aucune tâche annulée
                        </h3>
                        <p className="text-slate-500">
                          Vous n'avez aucune tâche annulée pour cette date.
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              </TabsContent>
            </Tabs>}
        </motion.div>
      </div>

      {detailTask && <TaskDetails task={detailTask} onClose={()=>setDetailTask(null)} onEdit={task=>{setDetailTask(null);handleEditTask(task);}} onChanged={()=>loadTasks(dayDate || selectedDate)} />}
      {isTaskModalOpen && (
        <TaskModal
          open={true}
          task={currentTask}
          takers={takers}
          isUpdating={isUpdating}
          onOpenChange={onOpenChange}
          updateOnCreate={updateOnCreate}
        />
      )}
    </div>

  );
};

export default Task;


const TaskCard = ({
  task,
  tasks,
  setTasks,
  filtrerTaches,
  activeTab,
  onEdit,
  onView,
  onDelete,
  onStatusChange,
  getStatusColor,
  getStatusLabel,
  getPriorityColor,
  getPriorityLabel,
}) => {
    const [isTaskStatusOpen, setIsTaskStatusOpen] = useState(false);
  const [statusCase, setStatusCase] = useState("");
  const [reportDate, setReportDate] = useState(null);
  const [cancelReason, setCancelReason] = useState(task.cancelReason);
  const [doneReason, setDoneReason] = useState(task.doneReason);
  const [currentDate] = useState(new Date());

  const close = () => {
    setIsTaskStatusOpen(false);
    setStatusCase("");
  };

  const doneTaskFunc = () => {
    axios
      .put(`newtask/${task._id}`, { status: "Effectuée", doneReason })
      .then((res) => {
        console.log(res);
        const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
        const newTasks = [...tasks];
        newTasks[taskIndex] = res.data;
        setTasks(newTasks);
        setReportDate(null);
        setCancelReason("");
        setIsTaskStatusOpen(false);
        setDoneReason("");
        filtrerTaches(activeTab, "", newTasks);
      })
      .catch((e) => console.log(e));
  };

  const cancelTaskFunc = () => {
    axios
      .put(`newtask/${task._id}`, { status: "annulée", cancelReason })
      .then((res) => {
        const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
        const newTasks = [...tasks];
        newTasks[taskIndex] = res.data;
        setTasks(newTasks);
        setReportDate(null);
        setIsTaskStatusOpen(false);
        setCancelReason("");
        setDoneReason("");
        filtrerTaches(activeTab, "", newTasks);
      });
  };

  const reportTaskDate = () => {
    axios.put(`newtask/${task._id}`, { date: reportDate }).then((res) => {
      const taskIndex = tasks.findIndex((task) => task._id === res.data._id);
      let newTasks = [...tasks];
      newTasks[taskIndex] = res.data;
      newTasks = newTasks.filter(
        (task) => formatJsDate(task.date) === formatJsDate(currentDate),
      );
      setTasks(newTasks);
      setReportDate(null);
      setIsTaskStatusOpen(false);
      setCancelReason("");
      setDoneReason("");
      filtrerTaches(activeTab, "", newTasks);
    });
  };

  return (
    <motion.div
      className="bg-white border border-slate-200 rounded-xl shadow-sm p-6 hover:shadow-md transition-all duration-300"
      whileHover={{ y: -2 }}
      layout
    >
      <Dialog open={isTaskStatusOpen} onOpenChange={close}>
        <DialogContent className="bg-white rounded-2xl shadow-2xl p-6 max-w-md mx-auto">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold text-slate-800 text-center flex items-center justify-center">
              <Activity className="w-5 h-5 mr-2 text-blue-600" />
              Statut de la tâche
            </DialogTitle>
          </DialogHeader>

          {/* Boutons de statut */}
          <div className="mt-6 flex justify-center gap-3">
            {["Effectuée", "Reportée", "Annulée"].map((status) => {
              const colors = {
                Effectuée: "bg-emerald-600 hover:bg-emerald-700",
                Reportée: "bg-amber-500 hover:bg-amber-600",
                Annulée: "bg-red-600 hover:bg-red-700",
              };
              const isActive = statusCase === status;

              return (
                <motion.button
                  key={status}
                  onClick={() => setStatusCase(status)}
                  className={`px-6 py-3 rounded-lg text-white font-medium transition-all duration-200 ${colors[status]} ${
                    isActive
                      ? "ring-2 ring-offset-2 ring-blue-500 scale-105 shadow-lg"
                      : "opacity-90 hover:opacity-100"
                  }`}
                  whileHover={{ scale: isActive ? 1.05 : 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {status}
                </motion.button>
              );
            })}
          </div>

          {/* Formulaire selon statut sélectionné */}
          <AnimatePresence mode="wait">
            {statusCase && (
              <motion.div
                className="mt-6 space-y-4"
              >
                {/* Effectuée */}
                {statusCase === "Effectuée" && (
                  <motion.div
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-2 block">
                        Décrivez l'action menée
                      </Label>
                      <textarea
                        placeholder="Décris l'action menée..."
                        onChange={(e) => setDoneReason(e.target.value)}
                        value={doneReason}
                        className="w-full min-h-[100px] border border-slate-300 rounded-lg px-4 py-3 text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 resize-none transition-colors duration-200"
                      />
                    </div>
                    <motion.button
                      onClick={() => doneTaskFunc()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-emerald-600 hover:bg-emerald-700 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <CheckCircle2 className="w-4 h-4" />
                      <span>Marquer comme effectuée</span>
                    </motion.button>
                  </motion.div>
                )}

                {/* Reportée */}
                {statusCase === "Reportée" && (
                  <motion.div
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-3 flex items-center">
                        <CalendarDays className="w-4 h-4 mr-2" />
                        Nouvelle date
                      </Label>
                      <div className="bg-slate-50 rounded-lg p-4">
                        <DayPicker
                          className="mx-auto"
                          showOutsideDays
                          mode="single"
                          locale={fr}
                          selected={reportDate}
                          onSelect={(date) => {
                            const newDate = new Date(date);
                            newDate.setHours(12);
                            setReportDate(newDate);
                          }}
                          classNames={{
                            day: "w-10 h-10 rounded-lg text-sm text-slate-700 hover:bg-amber-100 transition-colors duration-200",
                            selected: "bg-amber-500 text-white hover:bg-amber-600 transition-all duration-200",
                            today: "text-slate-900 font-semibold bg-slate-200",
                          }}
                        />
                      </div>
                    </div>
                    <motion.button
                      onClick={() => reportTaskDate()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-amber-500 hover:bg-amber-600 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <Clock className="w-4 h-4" />
                      <span>Reporter la tâche</span>
                    </motion.button>
                  </motion.div>
                )}

                {/* Annulée */}
                {statusCase === "Annulée" && (
                  <motion.div
                    className="space-y-4"
                  >
                    <div>
                      <Label className="text-sm font-medium text-slate-700 mb-2 block">
                        Raison de l'annulation
                      </Label>
                      <textarea
                        placeholder="Indique la raison de l'annulation..."
                        onChange={(e) => setCancelReason(e.target.value)}
                        value={cancelReason}
                        className="w-full min-h-[100px] border border-slate-300 rounded-lg px-4 py-3 text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 resize-none transition-colors duration-200"
                      />
                    </div>
                    <motion.button
                      onClick={() => cancelTaskFunc()}
                      className="w-full px-4 py-3 rounded-lg text-white font-semibold bg-red-600 hover:bg-red-700 transition-colors duration-200 flex items-center justify-center space-x-2"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <AlertCircle className="w-4 h-4" />
                      <span>Annuler la tâche</span>
                    </motion.button>
                  </motion.div>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </DialogContent>
      </Dialog>

      {/* Contenu Principal de la Carte */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <h3 className="text-lg font-semibold text-slate-900">{task.title}</h3>
            <Badge className={`${getPriorityColor(task.priority)} text-xs px-2 py-1`}>
              {getPriorityLabel(task.priority)}
            </Badge>
          </div>
          {(task.client?.name || (task.contactType === "interim" && task.candidate?.name)) && (
            <div className="flex items-center space-x-2 text-sm text-slate-600">
              <User className="w-4 h-4" />
              <span>
                {task.client?.name || (task.contactType === "interim" && task.candidate?.name) || ""}
              </span>
            </div>
          )}
        </div>

        <div className="flex items-center space-x-2">
          <Badge className={`${getStatusColor(task.status)} text-xs px-3 py-1`}>
            {getStatusLabel(task.status)}
          </Badge>
          <motion.button
            onClick={() => setIsTaskStatusOpen(true)}
            className="flex items-center space-x-1 text-slate-500 hover:text-slate-700 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <MoreHorizontal className="w-4 h-4" />
          </motion.button>
        </div>
      </div>

      {/* Description */}
      {task.comment && (
        <div className="mb-4 p-3 bg-slate-50 rounded-lg">
          <p className="text-sm text-slate-700">{task.comment}</p>
        </div>
      )}

      {/* Informations détaillées */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        {/* Assignée à */}
        {task.taskManagers && task.taskManagers.length > 0 && (
          <div className="flex items-start space-x-2">
            <Users className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Assignée à</p>
              {task.taskManagers.map((manager, index) => (
                <p key={index} className="text-sm text-slate-700">
                  {manager.firstname} {manager.lastname}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* Candidats */}
        {task.candidates && task.candidates.length > 0 && (
          <div className="flex items-start space-x-2">
            <User className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Candidats</p>
              <div className="space-y-1">
                {task.candidates.map((candidate, index) => (
                  <div key={index} className="text-sm text-slate-700">
                    <span>{candidate.firstname} {candidate.lastname}</span>
                    {candidate.phone && (
                      <span className="text-xs text-blue-600 ml-2 bg-blue-50 px-2 py-0.5 rounded">
                        {candidate.phone}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Type */}
        <div className="flex items-start space-x-2">
          <Activity className="w-4 h-4 text-slate-500 mt-0.5" />
          <div>
            <p className="text-xs font-medium text-slate-500 mb-1">Type</p>
            <p className="text-sm text-slate-700">{task.type}</p>
          </div>
        </div>

        {/* Assignateur */}
        {task.taskCreator && (
          <div className="flex items-start space-x-2">
            <User className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Créée par</p>
              <p className="text-sm text-slate-700">
                {task.taskCreator.firstname} {task.taskCreator.lastname}
              </p>
            </div>
          </div>
        )}

        {/* Clients */}
        {task.clients && task.clients.length > 0 && (
          <div className="flex items-start space-x-2">
            <Users className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Clients</p>
              <div className="space-y-1">
                {task.clients.map((client, index) => (
                  <div key={index} className="text-sm text-slate-700">
                    <span>{client.companyName}</span>
                    {client.contactPhone && (
                      <span className="text-xs text-blue-600 ml-2 bg-blue-50 px-2 py-0.5 rounded">
                        {client.contactPhone}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Date et heure */}
        {task.hour && (
          <div className="flex items-start space-x-2">
            <Clock className="w-4 h-4 text-slate-500 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-slate-500 mb-1">Planifiée</p>
              <p className="text-sm text-slate-700">{task.hour}</p>
            </div>
          </div>
        )}
      </div>

      {/* Actions menées */}
      {(task.status === "Effectuée" && task.doneReason) && (
        <div className="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
          <div className="flex items-start space-x-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-600 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-emerald-700 mb-1">Action menée</p>
              <p className="text-sm text-emerald-800">{task.doneReason}</p>
            </div>
          </div>
        </div>
      )}

      {(task.status === "annulée" && task.cancelReason) && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-start space-x-2">
            <AlertCircle className="w-4 h-4 text-red-600 mt-0.5" />
            <div>
              <p className="text-xs font-medium text-red-700 mb-1">Raison d'annulation</p>
              <p className="text-sm text-red-800">{task.cancelReason}</p>
            </div>
          </div>
        </div>
      )}

      {/* Actions */}

      {/* Actions */}
      <div className="flex items-center justify-between pt-4 border-t border-slate-200">
        <div className="flex items-center space-x-2">
          <motion.button
            onClick={() => setIsTaskStatusOpen(true)}
            className="flex items-center space-x-1 px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Activity className="w-3 h-3" />
            <span>Changer statut</span>
          </motion.button>
        </div>

        <div className="flex items-center space-x-2">
          <motion.button
            onClick={onView}
            className="p-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Voir les détails"
          >
            <Eye className="w-4 h-4" />
          </motion.button>

          <motion.button
            onClick={onEdit}
            className="p-2 text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Modifier"
          >
            <Edit3 className="w-4 h-4" />
          </motion.button>

          <motion.button
            onClick={onDelete}
            className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4" />
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

